import React from 'react';

import noop from 'lodash/noop';

import PlusMinus from '@ott/plus-minus';
import Travellers, { TravellersItem } from '@ott/travellers';
import TravellersChildren from '@ott/travellers-children';
import declOfNum from '@ott/utility-decl-of-num';

import styles from './TravellersWrap.scss';

const adultsDecl = ['взрослый', 'взрослых', 'взрослых'];
const humanDecl = ['человек', 'человека', 'человек'];
const yearDecl = ['год', 'года', 'лет'];

const MAX_CHILDREN = 3;
const MIN_ADULTS = 1;
const MAX_ADULTS = 4;

const childrenAgeRange = {
  start: 0,
  end: 12,
};

class TravellersWrap extends React.PureComponent {
  static defaultProps = {
    onFocus: noop,
    onBlur: noop,
  };

  plusMinusClassNames = {
    quantity: styles.adultsQuantity,
  };

  getAgeTitle = (age) => {
    if (age === 0) {
      return 'До года';
    }

    return `${age} ${declOfNum(age, yearDecl)}`;
  };

  getSelectedAgeTitle = (age) => {
    if (age === 0) {
      return 'Ребёнок, до года';
    }

    return `Ребёнок, ${age} ${declOfNum(age, yearDecl)}`;
  };

  renderAdults() {
    const {
      adultsField: { input },
    } = this.props;

    return (
      <PlusMinus
        min={MIN_ADULTS}
        max={MAX_ADULTS}
        value={input.value}
        label={`${input.value} ${declOfNum(input.value, adultsDecl)}`}
        onChange={input.onChange}
        childrenClassNames={this.plusMinusClassNames}
      />
    );
  }

  renderChildren() {
    const {
      childrenField: { input },
    } = this.props;

    return (
      <TravellersChildren
        maxChildren={MAX_CHILDREN}
        childrenAges={input.value}
        childrenAgeRange={childrenAgeRange}
        onChildrenAgesChange={input.onChange}
        getAgeTitle={this.getAgeTitle}
        getSelectedAgeTitle={this.getSelectedAgeTitle}
      />
    );
  }

  render() {
    const { onFocus, onBlur, adultsField, childrenField, childrenClassNames } = this.props;

    const travellersCount = childrenField.input.value.length + adultsField.input.value;

    return (
      <Travellers
        triggerValue={`${travellersCount} ${declOfNum(travellersCount, humanDecl)}`}
        travellersList={
          <TravellersItem adultsNode={this.renderAdults()} childrenNode={this.renderChildren()} />
        }
        placeholder="Путешественники"
        onFocus={onFocus}
        onBlur={onBlur}
        withArrowIcon={true}
        hasDoneButton={true}
        childrenClassNames={{
          container: styles.container,
          ...childrenClassNames,
        }}
      />
    );
  }
}

export default TravellersWrap;
